import {
  AccountStatus,
  ExtensionApiFactory,
  IExtensionApiStrategy,
} from '~cdw-ae/common/frontend/browser-extension-api';

import { UserProfileState } from './user-profile.state';

import { rootStore } from '../extension-store/extension.store';
import UtilsService from '../utils/utils.service';

const { setEmail, setId, setDomain } = UserProfileState.actions;

let extensionApi: IExtensionApiStrategy;

const UserProfileService = {
  init: async (): Promise<void> => {
    UtilsService.debugLog('User Profile Service Init');
    extensionApi = ExtensionApiFactory();
    return extensionApi.getUserProfile({ accountStatus: AccountStatus.SYNC }).then((userProfile) => {
      if (userProfile.email) {
        rootStore.dispatch(setDomain(userProfile.email.split('@')[1]));
      }
      rootStore.dispatch(setEmail(userProfile.email));
      rootStore.dispatch(setId(userProfile.id));
      UtilsService.debugLog('User Profile:', { ...userProfile, domain: userProfile.email.split('@')[1] });
    });
  },
};

export default UserProfileService;
